<header class="bg-grad-blue-navy gold-rule isolate flex min-h-26 items-center justify-between gap-3 overflow-hidden rounded-b-3xl py-4 pr-4 pl-5">
  @if (header().back) {
  <button
    type="button"
    aria-label="Volver"
    data-test="section-header-back"
    class="btn-secondary relative z-10 grid size-6 shrink-0 place-items-center rounded-full text-white transition-transform duration-100 ease-out active:scale-95 motion-reduce:transition-none motion-reduce:active:scale-100"
    (click)="back()">
    <icon
      name="chevron-left"
      [size]="14" />
  </button>
  }

  <!-- El tamaño del título va aquí y el h1 lo hereda: con botón de volver baja a 20px. -->
  <div
    class="relative z-10 flex min-w-0 flex-1 flex-col gap-1"
    [class]="header().back ? 'text-xl leading-[1.6875rem]' : 'text-[1.625rem] leading-8'">
    <h1 class="font-display text-gold-cream">{{ header().title }}</h1>
    <p class="text-gold-cream/80 text-[0.8125rem] leading-[1.125rem] font-medium">{{ description() }}</p>
  </div>

  <div class="relative size-18 shrink-0">
    <!-- Anillos concéntricos alrededor de la ilustración; el header los recorta. -->
    <span
      aria-hidden="true"
      class="border-gold-peach/10 absolute top-1/2 left-1/2 size-[230px] -translate-1/2 rounded-full border"></span>
    <span
      aria-hidden="true"
      class="border-gold-peach/16 absolute top-1/2 left-1/2 size-40 -translate-1/2 rounded-full border"></span>
    <span
      aria-hidden="true"
      class="border-gold-peach/22 absolute top-1/2 left-1/2 size-25 -translate-1/2 rounded-full border"></span>

    <img
      priority
      [ngSrc]="header().image"
      width="72"
      height="72"
      class="relative size-18 object-contain drop-shadow-[0_6px_12px_rgb(0_0_0/0.35)]"
      alt="" />
  </div>
</header>
